import React from "react";
import { InputLabel, Divider, Typography, Grid } from "@common-ui/ui";
import { FrameRenderer } from "../Renderer";

const Custom = ({
  section,
  sectionItem,
  sectionId,
  sectionStep,
  subSectionStep,
  subSectionId,
  procedureStatus,
  mode,
}) => {
  let subSection;
  if (subSectionId) {
    subSection = section.items.find((section) => section.id === subSectionId);
  }
  const getStep = (id) => {
    if (subSection) {
      return `${subSectionStep}.${
        Array.from(subSection.steps).indexOf(id) + 1
      }`;
    }
    return Array.from(section.steps).indexOf(id) + 1;
  };
  return (
    <div>
      <Grid container spacing={1}>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel fontWeight="700">Step</InputLabel>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <InputLabel fontWeight="700">Label</InputLabel>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item md={1} xs={12}>
          <div>
            <Typography
              fontWeight="700"
              sx={{ mt: { md: 1.5 } }}
            >{`${sectionStep}.${getStep(sectionItem.id)}`}</Typography>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <Typography sx={{ mt: { md: 1.5 } }}>
              {sectionItem.label}
            </Typography>
          </div>
        </Grid>
        <Grid item md={12} xs={12}>
          <FrameRenderer url={sectionItem.url} mode={mode} />
        </Grid>
      </Grid>

      {/* <div>Coming Soon!</div>  */}
      <Divider sx={{ my: 2 }} />
    </div>
  );
};

export default Custom;
